module.exports = __webpack_public_path__ + "media/images/logos/ncce-logo-82a5e9bc3cb92f9363877352d345dbd1.svg";